import { Box } from '@aicon-dev/caas-core';

import { useCalendarDetailStore } from './store';

export const CalendarEvent = (props: any) => {
  const { setVisible, setCurItem } = useCalendarDetailStore();

  return (
    <>
      {props.event?.task_id ? (
        <Box
          onClick={(e) => {
            e.stopPropagation();
            setVisible(true);
            setCurItem(props.event);
          }}
          display={'flex'}
          alignItems={'center'}
          color={'#505050'}
          height={'100%'}
        >
          <Box minWidth={'2px'} height="100%" background={props.event?.color}></Box>
          <Box background={props.event?.color + '1a'} flex={1}>
            {props.event?.title}
          </Box>
        </Box>
      ) : (
        <Box
          onClick={(e) => {
            e.stopPropagation();
            setVisible(true);
            setCurItem(props.event);
          }}
          background={props.event?.color}
          px="2px"
          height={'100%'}
        >
          {props.event?.title}
        </Box>
      )}
    </>
  );
};
